(() => {
  const root = document.body.dataset.rootUrl || '/';
  const cartUrl = document.body.dataset.cartUrl || '/cart';
  let buying = false;

  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('.buy-form')) return;
    event.preventDefault();
    if (buying) return;

    const button = form.querySelector('button[type="submit"]');
    const status = form.querySelector('.form-status');
    const errorMessage = status?.dataset.error || 'Nie udało się dodać produktu. Spróbuj ponownie.';
    buying = true;
    if (button) button.disabled = true;
    if (status) status.textContent = '';
    form.setAttribute('aria-busy', 'true');

    try {
      const id = new FormData(form).get('id');
      if (!id) throw new Error(errorMessage);

      const existingResponse = await fetch(root + 'cart.js', {
        headers: { Accept: 'application/json' },
        signal: AbortSignal.timeout(10000)
      });
      if (!existingResponse.ok) throw new Error(errorMessage);
      const existing = await existingResponse.json();

      if (!existing.items.some(item => String(item.variant_id) === String(id))) {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
          signal: AbortSignal.timeout(15000)
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || errorMessage);
      }
      window.location.assign(cartUrl);
    } catch (error) {
      if (status) status.textContent = error.name === 'TimeoutError' ? errorMessage : (error.message || errorMessage);
      if (button) button.disabled = false;
      form.removeAttribute('aria-busy');
      buying = false;
    }
  });

  const dialog = document.querySelector('.preview-dialog');
  let previewTrigger;
  if (dialog && typeof dialog.showModal === 'function') {
    document.querySelectorAll('[data-preview]').forEach(link => {
      link.addEventListener('click', event => {
        event.preventDefault();
        previewTrigger = link;
        const img = dialog.querySelector('[data-preview-image]');
        if (img) { img.src = link.href; img.alt = link.dataset.title || ''; }
        const title = dialog.querySelector('[data-preview-title]');
        if (title) title.textContent = link.dataset.title || '';
        dialog.showModal();
      });
    });
    dialog.querySelector('[data-close-preview]')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => previewTrigger?.focus());
  }

  const productSticky = document.querySelector('.sticky-buy');
  const purchase = document.querySelector('.purchase-box');
  const end = document.querySelector('.final-purchase');
  if (productSticky && purchase && 'IntersectionObserver' in window) {
    let mainVisible = true, endVisible = false;
    const update = () => {
      productSticky.hidden = mainVisible || endVisible || purchase.getBoundingClientRect().top > 0;
      document.body.classList.toggle('has-sticky-buy', !productSticky.hidden);
    };
    new IntersectionObserver(entries => { mainVisible = entries[0].isIntersecting; update(); }).observe(purchase);
    if (end) new IntersectionObserver(entries => { endVisible = entries[0].isIntersecting; update(); }).observe(end);
  }

  const homeSticky = document.querySelector('[data-m3-sticky]');
  const heroOffer = document.querySelector('.m3-hero-offer');
  const finalOffer = document.querySelector('.m3-final');
  if (homeSticky && heroOffer && 'IntersectionObserver' in window) {
    let heroVisible = true, finalVisible = false;
    const update = () => { homeSticky.hidden = heroVisible || finalVisible || heroOffer.getBoundingClientRect().top > 0; };
    new IntersectionObserver(entries => { heroVisible = entries[0].isIntersecting; update(); }, { threshold: .05 }).observe(heroOffer);
    if (finalOffer) new IntersectionObserver(entries => { finalVisible = entries[0].isIntersecting; update(); }, { threshold: .1 }).observe(finalOffer);
  }

  const revealItems = document.querySelectorAll('[data-reveal]');
  if (revealItems.length) {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      revealItems.forEach(item => item.classList.add('is-in'));
    } else {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.remove('reveal-pending');
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -7% 0px', threshold: .07 });
      revealItems.forEach(item => {
        if (item.getBoundingClientRect().top < window.innerHeight) { item.classList.add('is-in'); return; }
        item.classList.add('reveal-ready', 'reveal-pending');
        const siblings = [...item.parentElement.children].filter(el => el.matches('[data-reveal]'));
        item.style.setProperty('--reveal-delay', Math.min(siblings.indexOf(item), 3) * 60 + 'ms');
        observer.observe(item);
      });
      window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', event => {
        if (event.matches) { observer.disconnect(); revealItems.forEach(item => item.classList.remove('reveal-pending')); }
      });
    }
  }
})();
(() => {
  const section = document.querySelector('.m3-reviews');
  if (!section) return;
  const dialog = section.querySelector('dialog');
  let trigger;
  section.addEventListener('click', event => {
    const link = event.target.closest('[data-review-open]');
    if (!link || !dialog || typeof dialog.showModal !== 'function') return;
    event.preventDefault();
    trigger = link;
    const image = dialog.querySelector('[data-review-image]');
    image.src = link.href;
    image.alt = link.dataset.reviewAlt || '';
    dialog.showModal();
    dialog.scrollTop = 0;
  });
  dialog?.querySelector('[data-review-close]')?.addEventListener('click', () => dialog.close());
  dialog?.addEventListener('click', event => { if (event.target === dialog) { const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close(); } });
  dialog?.addEventListener('close', () => trigger?.focus({preventScroll:true}));
  const track = section.querySelector('.m3-reviews-track');
  const cards = [...track.querySelectorAll('.m3-review')];
  const controls = section.querySelector('.m3-reviews-controls');
  const previous = controls.querySelector('[data-review-prev]');
  const next = controls.querySelector('[data-review-next]');
  const count = controls.querySelector('[data-review-count]');
  let index = 0, scheduled = false;
  const update = () => {
    scheduled = false;
    const left = track.getBoundingClientRect().left;
    let distance = Infinity;
    cards.forEach((card, i) => { const d = Math.abs(card.getBoundingClientRect().left - left); if (d < distance) { distance = d; index = i; } });
    previous.disabled = index === 0;
    next.disabled = index === cards.length - 1;
    count.textContent = `${index + 1} / ${cards.length}`;
  };
  const move = step => {
    index = Math.max(0, Math.min(cards.length - 1, index + step));
    const left = cards[index].getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
    track.scrollTo({left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  };
  previous.addEventListener('click', () => move(-1));
  next.addEventListener('click', () => move(1));
  track.addEventListener('keydown', event => { if (event.target !== track || !matchMedia('(max-width:699px)').matches) return; if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); } });
  track.addEventListener('scroll', () => { if (!scheduled) { scheduled = true; requestAnimationFrame(update); } }, {passive:true});
  window.addEventListener('resize', update, {passive:true});
  controls.hidden = false;
  update();
})();
